import { render, staticRenderFns } from "./WorkoutVideoCard.vue?vue&type=template&id=3d340aa2&scoped=true&"
import script from "./WorkoutVideoCard.vue?vue&type=script&lang=js&"
export * from "./WorkoutVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutVideoCard.vue?vue&type=style&index=0&id=3d340aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d340aa2",
  null
  
)

export default component.exports